import { jsx } from '@emotion/core';
import OutsideClickHandler from 'react-outside-click-handler';
import { PresetDropdownWrapper, Content, PresetHeader, PresetSelect, TextButton } from './styled';

var Dropdown = function Dropdown(_a) {
  var _b = _a.handle,
      handle = _b === void 0 ? 'handle' : _b,
      _c = _a.toggled,
      toggled = _c === void 0 ? false : _c,
      _d = _a.done,
      done = _d === void 0 ? 'Done' : _d,
      _e = _a.onOutsideClick,
      onOutsideClick = _e === void 0 ? function () {} : _e,
      children = _a.children;
  return jsx(PresetDropdownWrapper, null, jsx(OutsideClickHandler, {
    onOutsideClick: onOutsideClick
  }, handle, toggled && jsx(PresetSelect, {
    "aria-label": "Select navigation item"
  }, jsx(PresetHeader, null, jsx(TextButton, {
    onClick: onOutsideClick
  }, done)), jsx(Content, null, children))));
};

export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/daterange/presetDropdown.js
// module id = 1034
// module chunks = 0